import { useState, useEffect, useRef } from "react";
import styles from "./dropdownfilter.module.css";
import DropDownIcon from "../Icons/DropDownIcon";
import { useGlobalContext } from "../../Context/GlobalContext";
import { formatDateToDDMMYYYY } from "../../Utils/utils";

const DropdownRepeatBookingDates = ({
	dates = [],
	onSelect,
	onOpen,
	dropdownClass,
	dropdownToggleClass,
	dropdownMenuClass,
	placeholder = "Select a date",
	placeholderClass = styles.placeholder,
	isLoading = false,
	emptyMessage = null,
}) => {
	const { selectedDate } = useGlobalContext();
	const [isDropdownOpen, setDropdownOpen] = useState(false);
	const dropdownRef = useRef(null);
	const dropdownMenuRef = useRef(null);

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target)
			) {
				setDropdownOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	// Auto-scroll dropdown into view inside scrollable parent
	useEffect(() => {
		if (isDropdownOpen && dropdownMenuRef.current) {
			dropdownMenuRef.current.scrollIntoView({
				behavior: "smooth",
				block: "nearest",
			});
		}
	}, [isDropdownOpen]);

	// Close dropdown after 1s when showing response message (empty dates with emptyMessage)
	useEffect(() => {
		if (isDropdownOpen && !isLoading && dates.length === 0 && emptyMessage) {
			const timer = setTimeout(() => setDropdownOpen(false), 2500);
			return () => clearTimeout(timer);
		}
	}, [isDropdownOpen, isLoading, dates.length, emptyMessage]);

	const handleSelect = (dateObj) => {
		if (onSelect) {
			onSelect(dateObj);
		}
		setDropdownOpen(false);
	};

	const displayText = placeholder;

	return (
		<div
			ref={dropdownRef}
			className={`${dropdownClass} commonDropdownNoImage`}
			tabIndex={0}>
			<div
				className={`dropdownToggle ${dropdownToggleClass} ${placeholderClass}`}
				onClick={() => {
					if (!isDropdownOpen) {
						onOpen?.();
					}
					setDropdownOpen(!isDropdownOpen);
				}}>
				{displayText}
				<div className={`${styles.arrow} ${isDropdownOpen ? styles.up : ''}`}>
					<DropDownIcon size={12} />
				</div>
			</div>
			{isDropdownOpen && (
				<ul className={`dropdownMenu ${dropdownMenuClass}`} ref={dropdownMenuRef}>
					{isLoading ? (
						<li className="dropdownItem">Loading...</li>
					) : dates.length > 0 ? (
					dates.map((dateObj, index) => {
						const dateText = dateObj.date || dateObj;
						// Compare selectedDate (Date object) with dateObj.date (DD-MM-YYYY string)
						const selectedDateStr = selectedDate ? formatDateToDDMMYYYY(selectedDate) : null;
						const isSelected = selectedDateStr === dateObj.date;
						return (
							<li
								key={index}
								className={`dropdownItem ${isSelected ? styles.selectedItem : ''} ${isSelected ? styles.disabledItem : ''}`}
								onClick={() => !isSelected && handleSelect(dateObj)}
								data-selected={isSelected}
								style={isSelected ? { pointerEvents: 'none', cursor: 'not-allowed', opacity: 0.6 } : {}}
							>
								{dateText}
							</li>
						);
					})
					) : (
						<li className={`${styles.repeatBookingEmptyMessage} dropdownItem`}>{emptyMessage || "No dates available"}</li>
					)}
				</ul>
			)}
		</div>
	);
};

export default DropdownRepeatBookingDates;
